import { render, staticRenderFns } from "./BackOfficeTab.vue?vue&type=template&id=806c44c2&scoped=true"
import script from "./BackOfficeTab.vue?vue&type=script&lang=js"
export * from "./BackOfficeTab.vue?vue&type=script&lang=js"
import style0 from "./BackOfficeTab.vue?vue&type=style&index=0&id=806c44c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806c44c2",
  null
  
)

export default component.exports